import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { featuredComics } from '@/mocks/comics';

export default function FeaturedSection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              编辑精选
            </h2>
            <p className="text-foreground-500 text-sm">精心挑选的高质量韩漫，品质保障</p>
          </div>
          <Link
            to="/category/romance"
            className="hidden sm:flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} variant="featured" />
          ))}
        </div>
      </div>
    </section>
  );
}